<script lang="ts">
	import { LabelListV2 } from '@Shelly/shelly-design-system';
	import { getCameraStatusLabelList } from 'src/components/Camera/helpers/camera-helpers';
	import type { Device } from 'src/types/Device';
	import type { DeviceStatusG2 } from 'src/types/DeviceStatusG2';
	import type { DeviceSettingsG2 } from 'src/types/DeviceSettings';

	export let device: Device;
	export let status: DeviceStatusG2;
	export let settings: DeviceSettingsG2;

	$: labelList = getCameraStatusLabelList(device, status, settings);
</script>

{#if labelList?.length}
	<LabelListV2
		backgroundColor="--color-0"
		{labelList}
		size="m"
		a11yProps={{ isInteractive: true }}
		isDefaultCursor
		data-prevent-drawer-swipe
		data-prevent-sidepanel-swipe
	/>
{/if}
